import { Component, Input } from '@angular/core';
import { Grant } from '../../_models/grant';

@Component({
  moduleId: module.id,
  selector: 'narrative',
  templateUrl: 'narrative.component.html',
  styleUrls: ['narrative.component.css']
})
export class NarrativeComponent {
  @Input()
  public grant: Grant;
}




// WEBPACK FOOTER //
// ./src/app/grant-form/narrative/narrative.component.ts